import React, { useEffect, useState } from 'react'
import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import ServiceFooter from "../../ServiceFooter";
import { Link } from 'react-router-dom';
import './cadanoBlockChain.css';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { builtCaroslData, chooseCaroslData } from './data';
import { faLeanpub } from '@fortawesome/free-brands-svg-icons';

const CadanoBlockChain = () => {

     const [isVertical, setIsVertical] = useState(window.innerWidth >= 992);

        var builtCaroslsetng = {
        dots: true,
        // infinite: true,
        className: "center",
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: !isVertical,

        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };


    useEffect(() => {
        const handleResize = () => {
            setIsVertical(window.innerWidth >= 992);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

        var chooseCaroslsetng = {
        dots: true,
        // infinite: true,
        // vertical: true,
        // verticalSwiping: true,
        // className: "center",
        // centerMode: false,
        // centerPadding: "60px",
        // adaptiveHeight: false,
        // autoplay: true,
        // slidesToShow: 1,
        // slidesToScroll: 1,

        dots: true,
        infinite: true,
        vertical: isVertical,
        verticalSwiping: isVertical,
        centerMode: isVertical,
        centerPadding: isVertical ? "0px" : "0px",
        autoplay: true,
        arrows: true,
        slidesToScroll: 1,
        adaptiveHeight: !isVertical,
        slidesToShow: 1, // default for desktop

        responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: isVertical ? 1 : 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
          centerMode: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
          centerMode: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
          centerMode: false,
        },
      },
    ],

    };

    return (
        <div className="cardano_txtcontent cardano_main_wrp">
            <NewHead />

            <Helmet>
                <title>Cardano Blockchain Development Company</title>
                <link
                    rel="canonical"
                    href="https://beleaftechnologies.com/cardano-blockchain-development-company"
                />
                <meta
                    name="title"
                    content="Cardano Blockchain Development Company "
                />
                <meta
                    name="description"
                    content="Selecting the right Cardano Blockchain Development Company necessitates careful assessment and evaluation of various aspects. Beleaf Technology offers expert solutions and guidance to help you choose the ideal company for your project. Explore our services today!"
                />

                <meta
                    property="og:title"
                    content="Cardano Blockchain Development Company "
                />
                <meta property="og:site_name" content="Beleaf Technologies" />
                <meta
                    property="og:url"
                    content="https://beleaftechnologies.com/cardano-blockchain-development-company"
                />
                <meta
                    property="og:description"
                    content="Selecting the right Cardano Blockchain Development Company necessitates careful assessment and evaluation of various aspects. Beleaf Technology offers expert solutions and guidance to help you choose the ideal company for your project. Explore our services today!"
                />
                <meta property="og:type" content="website" />

                <meta name="twitter:card" content="summary" />
                <meta name="twitter:site" content="@BeleafTech" />
                <meta
                    name="twitter:title"
                    content="Cardano Blockchain Development Company "
                />
                <meta
                    name="twitter:description"
                    content="Selecting the right Cardano Blockchain Development Company necessitates careful assessment and evaluation of various aspects. Beleaf Technology offers expert solutions and guidance to help you choose the ideal company for your project. Explore our services today!"
                />

                <meta name="twitter:image:alt" content="Beleaf Technologies" />
            </Helmet>

            <main className='cardano_mainWrp'>

                {/* section 1 */}
                <section className='crdbclk_hero_sct crdbclk_commn_sct'>
                    <div className='crdbclk_hero_cont crdbclk_cmmn_cont'>
                        <div className='crdbclk_hero_wrp'>
                            <div className='crdbclk_hero_lftcnt'>
                                <h5><span>Cardano</span> Blockchain Development Company</h5>
                                <p>Harness Cardano's Power: Revolutionize Your Business with Exceptional Blockchain Solutions</p>
                                <button>
                                    <Link to={"/contact-us"} ><span><img className='button_star_img' alt="Cardano Blockchain Development Company" src={require('../../../image/CadanoBlockChain/button_star_img.webp')} /></span> Get free consultation</Link>
                                </button>
                            </div>
                            <div className='crdbclk_hero_imgwrp'>
                                <img className='crdbclk_hero_img' 
                                alt="Cardano Blockchain Development Company" 
                                loading="lazy" 
                                src={`https://res.cloudinary.com/dvym3pvnu/image/upload/v1776940989/crdbclk_hero_img_dgyney.webp`} />
                            </div>
                        </div>
                    </div>
                </section>

                {/* section 2 */}
                <section className='crdbclk_choose_sct crdbclk_commn_sct'>
                    <div className='crdbclk_choose_cont crdbclk_cmmn_cont'>
                        <div className='crdbclk_choose_wrp'>
                            <div className='crdbclk_choose_lftImg'>
                                <div className='crdbclk_chooseslider_main'>
                                    <Slider className="crdbclk_chooseslider_wrp" {...chooseCaroslsetng}>
                                        {
                                            chooseCaroslData.map((Item, index) => {
                                                return (
                                                    <div key={index} className="crdbclk_chooseslider_crd">
                                                            <div className='crdbclk_choose_crd_img'>
                                                                <img alt="Cardano Blockchain Development Company" loading="lazy" src={Item.image} />
                                                            </div>
                                                            <h4>{Item.title}</h4>
                                                            <p>{Item.description}</p>
                                                    </div>
                                                )
                                            })
                                        }
                                    </Slider>
                                </div>
                            </div>
                            <div className='crdbclk_choose_rgtcnt'>
                                <h5 className='crdbclk_cmmn_title'>How to choose a <span>cardano blockchain</span> <span>development company?</span></h5>
                                <p className='crdbclk_cmmn_decp'>Selecting the right Cardano blockchain development company necessitates careful assessment and evaluation of various aspects. 
                                    Here are some essential steps to guide you in choosing the ideal company for your project</p>
                                <button data-toggle="modal" data-target="#myModal"><Link to={""}>Get Demo Now</Link></button>
                            </div>
                        </div>
                    </div>
                </section>

                {/* section 3 */}
                <section className='crdbclk_fects_sct crdbclk_commn_sct'>
                    <div className='crdbclk_fects_cont crdbclk_cmmn_cont'>
                        <div className='crdbclk_fects_wrp'>
                            <img className='crdbclk_fects_rgtball' alt='Cardano Blockchain Development Company' src={`https://res.cloudinary.com/dvym3pvnu/image/upload/v1778054878/crdbclk_fects_ballnew_hnjm98.webp`} />
                            <img className='crdbclk_fects_lftball' alt='Cardano Blockchain Development Company' src={`https://res.cloudinary.com/dvym3pvnu/image/upload/v1778054878/crdbclk_fects_ballnew_hnjm98.webp`} />
                            <h5 className='crdbclk_fects_title crdbclk_cmmn_title'>
                                Key <span>Features</span> and <span>Advantages of Cardano</span>
                            </h5>
                            <div className='crdbclk_fects_row'>
                                <div className='crdbclk_fects_crd_sm'>
                                    <div className='crdbclk_fects_crd'>
                                        <img alt="Cardano Blockchain Development Company" loading="lazy" src={require('../../../image/CadanoBlockChain/crdbclk_fects_img1.webp')} />
                                        <h3>Scalability</h3>
                                        <p>Is a key feature of Cardano, achieved through its unique consensus algorithm called Ouroboros. 
                                            This algorithm ensures high scalability without compromising security. 
                                            By dividing the blockchain into epochs and implementing a proof-of-stake (PoS) mechanism, 
                                            Cardano has the capability to process a significant number of transactions per second. 
                                            eUTXO ledgers allow for transaction parallelization, which reduces congestion. 
                                            This makes it well-suited for enterprise-level applications.
                                        </p>
                                    </div>
                                </div>
                                <div className='crdbclk_fects_crd_lg'>
                                    <div className='crdbclk_fects_crd'>
                                        <img alt="Cardano Blockchain Development Company" loading="lazy" src={require('../../../image/CadanoBlockChain/crdbclk_fects_img2.webp')} />
                                        <h3>Security</h3>
                                        <p>Is one of the founding principles of Cardano, ensuring a robust and trustworthy platform. 
                                            The implementation of rigorous auditing processes and the utilization of formal verification techniques sets Cardano apart. 
                                            By employing formal methods, Cardano achieves mathematically proven security properties, 
                                            significantly reducing the risks associated with vulnerabilities and attacks. As a result, 
                                            applications and smart contracts built on Cardano demonstrate exceptional resilience and resistance to tampering, 
                                            providing users with a high level of confidence in the integrity of their transactions and data.
                                        </p>
                                    </div>
                                </div>
                                <div className='crdbclk_fects_crd_lg'>
                                    <div className='crdbclk_fects_crd'>
                                        <img alt="Cardano Blockchain Development Company" loading="lazy" src={require('../../../image/CadanoBlockChain/crdbclk_fects_img3.webp')} />
                                        <h3>Sustainability</h3>
                                        <p>Is a fundamental principle embedded in Cardano's development approach. 
                                            Recognizing the environmental impact and energy consumption of traditional proof-of-work (PoW) blockchains, 
                                            Cardano has implemented a proof-of-stake (PoS) consensus mechanism. 
                                            This transition enables Cardano to significantly reduce energy consumption while upholding network security and decentralization. 
                                            By adopting PoS, Cardano demonstrates its commitment to creating a more sustainable blockchain 
                                            ecosystem without compromising on the vital aspects of security and decentralization.
                                        </p>
                                    </div>
                                </div>
                                <div className='crdbclk_fects_crd_sm'>
                                    <div className='crdbclk_fects_crd'>
                                        <img alt="Cardano Blockchain Development Company" loading="lazy" src={require('../../../image/CadanoBlockChain/crdbclk_fects_img4.webp')} />
                                        <h3>Interoperability</h3>
                                        <p>as a key goal for Cardano, The platform aims to establish seamless interoperability between different blockchain 
                                            networks and legacy systems. This enables developers to leverage the benefits of Cardano while seamlessly 
                                            integrating and connecting with other blockchain platforms and traditional infrastructure. 
                                            Such interoperability fosters collaboration and expands the potential use cases of decentralized applications. 
                                            Cardano allows multiple currencies to exist side by side and seamlessly move across multiple chains. 
                                            Cardano also allows the addition of metadata to a transaction to define who made the transaction.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* section 4 */}
                <section className='crdbclk_build_sct crdbclk_commn_sct'>
                    <div className='crdbclk_build_cont crdbclk_cmmn_cont'>
                        <div className='crdbclk_build_wrp'>
                            <h5 className='crdbclk_cmmn_title'>What can be built on the <span>Cardano blockchain platform</span></h5>
                            <div className='crdbclk_slider_main'>
                                <Slider className="crdbclk_slider_wrp" {...builtCaroslsetng}>
                                    {
                                        builtCaroslData.map((Item, index) => {
                                            return (
                                                <div key={index} className="crdbclk_slider_crd">
                                                    <div className='crdbclk_slider_crdcnt'>
                                                        <h4>{Item.title}</h4>
                                                        <p>{Item.description}</p>
                                                    </div>
                                                    <div className='crdbclk_slider_crdimg'>
                                                        <img alt="Cardano Blockchain Development Company" loading="lazy" src={Item.image} />
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </Slider>
                            </div>
                        </div>
                    </div>
                </section>

                {/* section 5 */}
                <section className='crdbclk_custm_sct crdbclk_commn_sct'>
                    <div className='crdbclk_custm_cont crdbclk_cmmn_cont'>
                        <div className='crdbclk_custm_wrp'>
                            <div className='crdbclk_custm_lft'>
                                <img className='crdbclk_custm_img' alt='Cardano Blockchain Development Company' src={`https://res.cloudinary.com/dvym3pvnu/image/upload/v1776943613/crdbclk_custm_img2_y6b1qs.webp`} />
                            </div>
                            <div className='crdbclk_custm_rgt'>
                                <h5 className='crdbclk_cmmn_title'><span>Custom Full Suite DApp</span> on the Cardano blockchain platform</h5>
                                <p className='crdbclk_cmmn_decp'>Comprehensive decentralized application tailored specifically for the Cardano ecosystem. 
                                    Leveraging features like smart contracts and native assets, this DApp offers a secure and scalable 
                                    solution for various use cases, including staking, governance, Defi, and digital identity. 
                                    With Cardano's focus on scalability and interoperability, It provides a seamless and efficient 
                                    user experience while benefiting from the advanced capabilities of the Cardano blockchain.</p>
                                <button>
                                    <Link to={"/contact-us"} ><span><img className='button_star_img' alt="Cardano Blockchain Development Company" src={require('../../../image/CadanoBlockChain/button_star_img.webp')} /></span> Contact Now</Link>
                                </button>
                            </div>
                        </div>
                    </div>
                </section>

                {/* section 6 */}
                <section className='crdbclk_chat_sct crdbclk_commn_sct'>
                    <div className='crdbclk_chat_cont crdbclk_cmmn_cont'>
                        <div className='crdbclk_chat_wrp'>
                            <h5>Empower Your Business Platform With Our Cardano Blockchain Development Solution! Let’s Chat</h5>
                            <button><Link to={'/contact-us'}><span><img className='button_star_img' alt='Cardano Blockchain Development Company' src={require('../../../image/CadanoBlockChain/button_star_img.webp')} /></span> Get free consultation</Link></button>
                        </div>
                    </div>
                </section>

            </main>

            {/* <Footer /> */}
            <ServiceFooter />
        </div>
    )
}

export default CadanoBlockChain